// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-C":"C_sp-175w-C__C7Zbp"};